export default __webpack_public_path__ + "static/media/img_profile.ff932284.png";